export const unitSizeMetadata = [
  { id: "Sro", label: "SRO" },
  { id: "Studio", label: "Studio" },
  { id: "1br", label: "1 bedroom" },
  { id: "1br_den", label: "1 bedroom + den" },
  { id: "2br", label: "2 bedroom" },
  { id: "3br", label: "3 bedroom" },
  { id: "4br", label: "4 bedroom" },
  { id: "5br", label: "5 bedroom" },
  { id: "Shared", label: "Shared" },
];
